module.exports = "<div class=\"container theme-showcase\" role=\"main\">\n    <router-outlet></router-outlet>\n</div> <!-- /container -->"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/sections/section-downloads/section-downloads.component.html
// module id = ./src/app/components/sections/section-downloads/section-downloads.component.html
// module chunks = main